<template>
  <bulk-details-block
    :title="title"
    class="bulk-details-grid"
  >
    <div :class="['bulk-details-grid__content', `bulk-details-grid__content--${preset}`]">
      <slot />
    </div>
  </bulk-details-block>
</template>

<script setup lang="ts">
import BulkDetailsBlock from '@/components/shared/bulkDetails/BulkDetailsBlock.vue'
import type { BulkDetailsGridPreset } from '@/components/shared/types'

const { preset = 'default' } = defineProps<{
  title?: string
  preset?: BulkDetailsGridPreset
}>()
</script>

<style lang="scss" scoped>
$gap: 24px;

.bulk-details-grid {
  &__content {
    display: grid;
    gap: $gap;
    align-items: start;
    grid-template-columns: 1fr;

    & > * {
      min-width: 0;
    }

    &--default {
      @include media-lg-min {
        grid-template-columns: 1fr 1fr;
      }
    }

    &--narrow-left {
      @include media-xl-min {
        grid-template-columns: 1fr 1fr;
      }

      @include media-xxl-min {
        grid-template-columns: 40% 1fr;
      }

      @include media-4xl-min {
        grid-template-columns: 646px 1fr;
      }
    }

    &--column {
      display: flex;
      flex-direction: column;

      & > * {
        width: 100%;
      }
    }

    &--column-reverse {
      display: flex;
      align-items: normal;
      flex-direction: column-reverse;

      & > * {
        width: 100%;
      }
    }

    &--mobile-reverse {
      display: flex;
      align-items: normal;
      flex-direction: column-reverse;

      @include media-lg-min {
        flex-direction: row;

        & > * {
          flex: 1 1 0;
        }
      }
    }
  }
}
</style>
